const NoRelatedTherapies = (props) => {
  return(
    <div>
      <p>No matching drugs found.</p>
    </div>
  );
};

export default NoRelatedTherapies;
